// ヘッダースティッキー
if(document.querySelector('.sticky-header_all') != null){
	const sticky_header_all = document.querySelector('.sticky-header_all');
	const sticky_padding = document.querySelector('.sticky_padding');
	let sticky_header_allTop = sticky_header_all.getBoundingClientRect();
	let sticky_header_allTop_position = sticky_header_allTop.top + window.pageYOffset;
	let sticky_header_all_height = sticky_header_all.clientHeight;
	let sticky_header_Animation = function() {
		let header_scroll_position = window.pageYOffset;
		if(header_scroll_position > sticky_header_allTop_position){
  		sticky_header_all.classList.add('sticky_on');
		sticky_padding.style.paddingTop = sticky_header_all_height + "px";
 		}  else {
  	sticky_header_all.classList.remove('sticky_on');
		sticky_padding.style.paddingTop = "0";
 	}
	}
	window.addEventListener('scroll', sticky_header_Animation);
}


// フッターTOPに戻る
if(document.getElementById("side_to_top_btn_sec") != null){
	const pageTop =  document.getElementById('side_to_top_btn_sec');
	const pageTopBtn1 =  document.getElementById('side_to_top_btn');
	let Animation = function() {
	//アイコン位置取得

	//要素の位置座標を取得
	let rect = pageTop.getBoundingClientRect();
	//topからの距離
	let scrollTop = rect.top + window.pageYOffset;

	if(scrollTop > 600){
		pageTop.classList.add('show');
		}  else {
		pageTop.classList.remove('show');
		}
	}
	window.addEventListener('scroll', Animation);
	pageTopBtn1.addEventListener("click", scroll_top);
}


// フッターTOPに戻る
if(document.getElementById("footer_to_top_btn") != null){
	const pagetopBtn = document.querySelector('#footer_to_top_btn');
	pagetopBtn.addEventListener("click", scroll_top);
};

function scroll_top() {
	window.scrollTo(0, 0);
}
  


// 別ホストのリンクを_blankで開く
window.addEventListener('DOMContentLoaded', function() {
  const links = document.links;
  const linksLength = links.length;
  for (let i = 0; i < linksLength ; i++) {
	if (links[i].hostname !== window.location.hostname) {
	  links[i].target = '_blank';
	  links[i].rel = 'noreferrer noopener';
	}
  }
});

// multiGridマウススクロール

jQuery.prototype.mousedragscrollable = function () {
	let target;
	$(this).each(function (i, e) {
		$(e).mousedown(function (event) {
			event.preventDefault();
			target = $(e);
			$(e).data({
				down: true,
				move: false,
				x: event.clientX,
				y: event.clientY,
				scrollleft: $(e).scrollLeft(),
				scrolltop: $(e).scrollTop(),
			});
			return false;
		});
		$(e).click(function (event) {
			if ($(e).data("move")) {
				return false;
			}
		});
	});
	$(document)
		.mousemove(function (event) {
			if ($(target).data("down")) {
				event.preventDefault();
				let move_x = $(target).data("x") - event.clientX;
				let move_y = $(target).data("y") - event.clientY;
				if (move_x !== 0 || move_y !== 0) {
					$(target).data("move", true);
				} else {
					return;
				}
				$(target).scrollLeft($(target).data("scrollleft") + move_x);
				$(target).scrollTop($(target).data("scrolltop") + move_y);
				return false;
			}
		})
		.mouseup(function (event) {
			$(target).data("down", false);
			return false;
		});
  };
  $(".multiGrid").mousedragscrollable();


//#header要素内の一番下に要素.a-tabFixedを移動させる
$(function(){
	// #header要素内の一番下に要素.a-tabFixedを移動させる
	$('.sticky-header_all').append($('.a-tabFixed'));

	var navPos = $( '.a-tabFixed--top' ).offset().top; 
	var navHeight = $( '.a-tabFixed--top' ).outerHeight(); 
	$(window).on('scroll', function(){
		if ( $( this ).scrollTop() > navPos ) {
			$( '.a-tabFixed--top' ).addClass( 'is-fixed' );
			$( '.sticky-header_all' ).addClass( 'is-fixed' );
		} else {
			$( '.a-tabFixed--top' ).removeClass( 'is-fixed' );
			$( '.sticky-header_all' ).addClass( 'is-fixed' );
		}
	});


});


// 動きのきっかけとなるアニメーションの名前を定義
function fadeAnime(){

	//ふわっと動くきっかけのクラス名と動きのクラス名の設定
	$('.fadeuptrigger').each(function(){ //fadeInUpTriggerというクラス名が
		var elemPos = $(this).offset().top+200; //要素より、50px上の
		var scroll = $(window).scrollTop();
		var windowHeight = $(window).height();
		if (scroll >= elemPos - windowHeight){
		$(this).addClass('fadeUp');
		// 画面内に入ったらfadeInというクラス名を追記
		}
		});
	
	//関数でまとめることでこの後に違う動きを追加することが出来ます
	$('.animation01').each(function(){ 
		var elemPos = $(this).offset().top+520; //要素より、50px上の
		var scroll = $(window).scrollTop();
		var windowHeight = $(window).height();
		if (scroll >= elemPos - windowHeight){
		$(this).addClass('is-active');
		}
		});
	
	
	}//ここまでふわっと動くきっかけのクラス名と動きのクラス名の設定
	
	// 画面をスクロールをしたら動かしたい場合の記述
		$(window).scroll(function (){
			fadeAnime();/* アニメーション用の関数を呼ぶ*/
		});// ここまで画面をスクロールをしたら動かしたい場合の記述
	


		$(function(){
			$('.bottomMenu__box.mega').hover(
			function() {
				//カーソルが重なった時
				$(this).children(".bottomMenu__inner").addClass("active");
			}, function() {
				//カーソルが離れた時
				$(this).children(".bottomMenu__inner").removeClass("active");
			}
		);

		});


		$(function(){
			$('.js-a-search').on('click', function(){
				$('.a-cart--sp').toggleClass('is-show');
			});
		});